import React from 'react';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';
import ButtonWrapper from '../../../../components/ButtonWrapper';

import './style.scss';

export interface NodePartnerCardProps {
  title: string;
  subtitle?: string;
  image?: React.ReactNode;
  linkText: string;
  linkUrl: string;
}

const NodePartnerCard: React.FC<NodePartnerCardProps> = (props) => {
  const {
    title,
    subtitle,
    image,
    linkText,
    linkUrl,
  } = props;

  return (
    <Card className="NodePartnerCard" withLink={false}>
      {image && (
        <div className="Card__image-wrapper">
          <Card.Image
            image={image}
          />
        </div>
      )}
      <Card.Content>
        <div className="Card__content__text">
          <Card.Title title={title} />

          <Card.Subtitle
            subtitle={(
              <WysiwygField html={subtitle} />
            )}
          />
        </div>

        {/* Add a hidden title since the linkText from Drupal is often just 'Read more' */}
        <ButtonWrapper href={linkUrl} type="textual">
          {linkText}
          <span className="visually-hidden">
            {` ${title}`}
          </span>
        </ButtonWrapper>
      </Card.Content>
    </Card>
  );
};

export default NodePartnerCard;
